export default "__VITE_ASSET__D8evL$PC__"